import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createRegionAPI,
  deleteRegionAPI,
  fetchRegionsAPI,
  updateRegionAPI,
} from "./regionsAPI";
import { showModal } from "../statusModal/statusModal";

const initialState = {
  list: [],
  fetchStatus: "idle",
  addStatus: "idle",
  updateStatus: "idle",
  deleteStatus: "idle",
  error: null,
};

export const fetchRegions = createAsyncThunk(
  "regions/fetchRegions",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const data = await fetchRegionsAPI();
      return data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء جلب البيانات", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch images"
      );
    }
  }
);

export const createRegion = createAsyncThunk(
  "regions/createRegion",
  async (regionData, { dispatch, rejectWithValue }) => {
    try {
      const data = await createRegionAPI(regionData);
      dispatch(
        showModal({
          message: `تم انشاء منطقة جديدة بنجاح`,
          status: "success",
        })
      );
      return data.data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء انشاء المنطقة", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete admins"
      );
    }
  }
);

export const deleteRegion = createAsyncThunk(
  "region/deleteRegion",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const data = await deleteRegionAPI(id);
      dispatch(
        showModal({
          message: `تم حذف المنطقة بنجاح`,
          status: "success",
        })
      );
      return data.data._id;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء حذف المنطقة", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete admin"
      );
    }
  }
);

export const updateRegion = createAsyncThunk(
  "region/updateRegion",
  async ({ regionId, regionData }, { dispatch, rejectWithValue }) => {
    try {
      const data = await updateRegionAPI(regionId, regionData);

      dispatch(
        showModal({
          message: `تم التعديل على المنطقة بنجاح`,
          status: "success",
        })
      );
      return data.data;
    } catch (error) {
      dispatch(
        showModal({
          message: "حصل خطأ اثناء التحديث على المنطقة",
          status: "error",
        })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete admins"
      );
    }
  }
);

const regionsSlice = createSlice({
  name: "regions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRegions.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(fetchRegions.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.list = action.payload.data;
      })
      .addCase(fetchRegions.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(createRegion.pending, (state) => {
        state.addStatus = "loading";
        state.error = null;
      })
      .addCase(createRegion.fulfilled, (state, action) => {
        state.addStatus = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(createRegion.rejected, (state, action) => {
        state.addStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(deleteRegion.pending, (state) => {
        state.deleteStatus = "loading";
        state.error = null;
      })
      .addCase(deleteRegion.fulfilled, (state, action) => {
        state.deleteStatus = "succeeded";
        state.list = state.list.filter(({ _id }) => _id !== action.payload);
      })
      .addCase(deleteRegion.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(updateRegion.pending, (state) => {
        state.updateStatus = "loading";
        state.error = null;
      })
      .addCase(updateRegion.fulfilled, (state, action) => {
        state.updateStatus = "succeeded";
        state.list = state.list.map((region) => {
          return region._id === action.payload._id ? action.payload : region;
        });
      })
      .addCase(updateRegion.rejected, (state, action) => {
        state.updateStatus = "failed";
        state.error = action.payload.error;
      });
  },
});

export default regionsSlice.reducer;
